import { render, staticRenderFns } from "./adList.vue?vue&type=template&id=2f27b306&scoped=true&"
import script from "./adList.vue?vue&type=script&lang=js&"
export * from "./adList.vue?vue&type=script&lang=js&"
import style0 from "./adList.vue?vue&type=style&index=0&id=2f27b306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27b306",
  null
  
)

export default component.exports